const compactFormat = new Intl.NumberFormat("en-US", {
    notation: "compact",
    minimumSignificantDigits: 2,
    maximumSignificantDigits: 3,
});
const scientificFormat = new Intl.NumberFormat("en-US", {
    notation: "scientific",
    minimumSignificantDigits: 2,
    maximumSignificantDigits: 3,
});

function format(number: number | bigint): string {
    if (number > 10 ** 6) {
        return scientificFormat.format(number).replace("E", "e");
    } else {
        return compactFormat.format(number);
    }
}

export interface NumProps {
    value: number | bigint;
    unit: string;
}

export function Num(props: NumProps) {
    const { value, unit } = props;

    return (
        <>
            {format(value)}
            {unit}
        </>
    );
}
